import React, { useEffect, useState } from 'react';

export function Appearer({ children, appeared = false, order = 0, template = 'lg', className = '', lazy = false }) {
  const [shown, setShown] = useState(appeared);

  useEffect(() => {
    if (shown) return undefined;
    const delay = lazy ? Math.floor(order / 4) * 16 : order * 30;
    const time = setTimeout(() => {
      setShown(true);
    }, delay);
    return () => {
      clearTimeout(time);
    };
  }, [shown, order, lazy]);

  return (
    <div className={`x_appearer ${template}${shown ? ' shown' : ''}${className ? ` ${className}` : ''}`}>
      {(!lazy || shown) ? children : null}
    </div>
  );
}
